import type { Feature } from 'geojson';
import { parse } from 'wellknown';
import { type TrafikverketRoadCondition } from './RoadConditionMessage';
import type { TrafikverketSourceOptions } from './Sources.types';
import { TrafikverketSource } from './TrafikverketSource';

const defaultOptions = (region: string): TrafikverketSourceOptions => ({
    id: 'road-condition-section-source',
    objectType: 'RoadCondition',
    schemaVersion: '1.2',
    query: `
        <FILTER>
            <AND>
                <IN name="CountyNo" value="${region === 'vst' ? '1' : '13,14'}" />
            </AND>
        </FILTER>
        <INCLUDE>Id</INCLUDE>
        <INCLUDE>LocationText</INCLUDE>
        <INCLUDE>Geometry.WGS84</INCLUDE>
    `,
    displayName: 'Väglag',
});

export interface RoadConditionSectionProperties extends TrafikverketRoadCondition {
    name: string;
    status: string;
}

export class RoadConditionSectionSource extends TrafikverketSource {
    constructor(region: string, options?: TrafikverketSourceOptions) {
        super({ ...defaultOptions(region), ...options });
    }

    parseData(roadConditions: TrafikverketRoadCondition[]): Feature[] {
        return roadConditions.map(function (rc) {
            const geoJSON = parse(rc.geometry.WGS84);
            return {
                id: rc.id,
                type: 'Feature',
                geometry: geoJSON,
                properties: {
                    name: rc.locationText,
                },
            };
        });
    }
}
